export const truncateAddress = (addr: string) =>
    addr.length > 10 ? `${addr.slice(0, 4)}...${addr.slice(-4)}` : addr;

export const getTierLabel = (tokenBalance?: number): string => {
    if (!tokenBalance || tokenBalance < 1_000_000) return "Free";
    if (tokenBalance < 10_000_000) return "Free - Level 1";
    return "Free - Level 2";
};

export const formatBalance = (value: number | undefined, digits = 2) => {
    if (value === null || value === undefined) return "N/A";
    return value.toLocaleString("en-US", {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    });
};

export const formatRelativeDate = (value?: string) => {
    if (!value) return "Never";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "Never";
    return date.toLocaleString();
};

export const formatNumber = (value: number, maxFractionDigits = 2) => {
    if (!Number.isFinite(value)) return "0";
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: maxFractionDigits }).format(value);
};

/**
 * Extract a user-friendly error message from an unknown catch value.
 * Works with Axios errors, native Errors, and string throws.
 */
export function getErrorMessage(err: unknown, fallback = "An error occurred"): string {
    if (typeof err === "object" && err !== null) {
        const axiosErr = err as { response?: { data?: { error?: string }; status?: number }; message?: string };
        if (axiosErr.response?.data?.error) return axiosErr.response.data.error;
        if (axiosErr.message) return axiosErr.message;
    }
    if (typeof err === "string") return err;
    return fallback;
}

/**
 * Extract HTTP status code from an Axios-like error. Returns undefined for non-HTTP errors.
 */
export function getErrorStatus(err: unknown): number | undefined {
    if (typeof err === "object" && err !== null) {
        const axiosErr = err as { response?: { status?: number } };
        return axiosErr.response?.status;
    }
    return undefined;
}

export const formatMethodName = (method: string) => {
    if (method === "defendFloor") return "Defend Floor";
    if (method === "stopLoss") return "Stop Loss";
    if (method === "takeProfit") return "Take Profit";
    if (method === "buyToPrice") return "Buy to Price";
    if (method === "sellToPrice") return "Sell to Price";
    return method.charAt(0).toUpperCase() + method.slice(1);
};
